import React, { useEffect, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { HiShare } from "react-icons/hi";
import moment from "moment";
import DesImg from "../../assets/destination.png";
import OrgImg from "../../assets/origin.png";
import ShareTripLink from "./ShareTripLink";
import "./TripDetails.scss";
import ConsentDetails from "./ConsentDetails ";

export function removeZFromTimestamp(timestamp) {
  return timestamp ? timestamp.replace(/Z$/, "") : "";
}

const TripDetails = ({ trackingData }) => {
  const [details, setDetails] = useState({});
  const [showShareLink, setShowShareLink] = useState(false);
  const [showConsentDetails, setShowConsentDetails] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true); // State to track first load

  useEffect(() => {
    const result = trackingData?.Location_Data?.Last_Known_Location
      ? {
          "Last Location": `Ping ${trackingData.Location_Data.Last_Known_Location.PingNumber || "-"} (${
            trackingData.Location_Data.Last_Known_Location.Source || "-"
          }) - ${trackingData.Location_Data.Last_Known_Location.address || "-"}`,
          "Last Location Time": trackingData.Location_Data.Last_Known_Location.recorded_at
            ? moment(removeZFromTimestamp(trackingData.Location_Data.Last_Known_Location.recorded_at)).format(
                "DD/MM/YYYY (hh:mm A)"
              )
            : "-",
          "Distance Remaining":
            trackingData.Location_Data.Last_Known_Location.distance_from_last_location &&
            trackingData.Location_Data.total_distance
              ? `${trackingData.Location_Data.Last_Known_Location.distance_from_last_location || "-"} / ${
                  trackingData.Location_Data.total_distance || "-"
                } KM`
              : "-",
          "Time Remaining": trackingData.Location_Data.Last_Known_Location.time_remained || "-",
          ETA: trackingData.Location_Data.Last_Known_Location.eta
            ? moment(trackingData.Location_Data.Last_Known_Location.eta).format("DD/MM/YYYY (hh:mm A)")
            : "-",
        }
      : {
          "Last Location": "-",
          "Last Location Time": "-",
          "Distance Remaining": "-",
          "Time Remaining": "-",
          ETA: "-",
        };
    setDetails({
      "Vehicle No": trackingData?.Vehicle_No ? trackingData?.Vehicle_No?.toUpperCase() : "-",
      ...result,
      "Sim Track Consent":
        trackingData?.consent_status && trackingData?.consent_status
          ? trackingData?.consent_status
          : "Tracking is not available!",
      "Driver App Status": trackingData?.Is_Driver_Status ? "Active" : "Inactive",
    });

    // Remove the animation after 3 seconds
    const timer = setTimeout(() => {
      setIsFirstLoad(false); // Remove the animation after 3 seconds
    }, 3000);

    return () => clearTimeout(timer); // Cleanup on component unmount
  }, [trackingData]);

  const handleShareClick = () => {
    setShowShareLink((prev) => !prev);
  };

  const handleConsentIconClick = () => {
    setShowConsentDetails((prev) => !prev);
  };

  const statusColor = trackingData?.Location_Data?.Truck_Travel_Status === "Delayed" ? "red" : "green"; // Dynamic color for status

  return (
    <div className="tripDetails__container">
      <div className="tripDetails__headerContainer">
        <h2 className="tripDetails__header">Tracking Details ({trackingData?.Location_Data?.TrackTrip_ID})</h2>
        <div className={isFirstLoad ? "tripDetails__shareIcon animated" : "tripDetails__shareIcon"}>
          <HiShare onClick={handleShareClick} />
        </div>
      </div>

      {showShareLink && (
        <div className="tripDetails__shareLinkContainer">
          <ShareTripLink tripId={trackingData?._id} setShowShareLink={setShowShareLink} />
        </div>
      )}

      <div className="tripDetails__status_container">
        <div>
          <div className="tripDetails__flexContainer">
            <img src={OrgImg} alt="Origin" className="tripDetails__image" />
            <span className="tripDetails__city">{trackingData?.Location_Data?.Origin?.City}</span>
          </div>

          <div className="tripDetails__flexContainer">
            <img src={DesImg} alt="Destination" className="tripDetails__image" />
            <span className="tripDetails__city">{trackingData?.Location_Data?.Destination?.City}</span>
          </div>
        </div>

        {/* Status with dynamic color */}
        <div className="tripDetails__status" style={{ color: statusColor }}>
          {trackingData?.Location_Data?.Truck_Travel_Status}
        </div>
      </div>

      <div className="tripDetails__detailsContainer">
        {Object.entries(details).map(([key, value]) => (
          <div key={key} className="tripDetails__detailRow">
            <div className="tripDetails__detailLabel">{key}</div>
            <div className="tripDetails__Dash">-</div>
            <div className="tripDetails__detailValue">
              {key === "Sim Track Consent" ? (
                <div className="tripDetails__consentContainer">
                  <span className="tripDetails__consentText">{value}</span>
                  {value === "Pending" && (
                    <>
                      <AiOutlineInfoCircle
                        className="tripDetails__consentDetailsContainer"
                        onClick={handleConsentIconClick}
                      />
                      {showConsentDetails && (
                        <div className="tripDetails__consentDetailsContainer">
                          <ConsentDetails
                            onClose={() => setShowConsentDetails(false)}
                            carrier={trackingData?.carrier}
                            status={trackingData?.consent_status}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : key === "Driver App Status" ? (
                <div className="tripDetails__driverAppStatusContainer">
                  <span className="tripDetails__driverAppStatusText">
                    {
                      <div
                        className={value === "Active" ? "statusActive" : value === "Inactive" ? "statusInactive" : ""}
                      >
                        {value}
                      </div>
                    }
                  </span>
                </div>
              ) : (
                <span>{value}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TripDetails;
